<template>
  <div
    id="images"
    class="pt-10"
    data-aos="fade-in"
    data-aos-easing="ease-in-out"
    data-aos-duration="500"
  >
    <Title text="Images" />

    <LoadingSpinner v-if="loading" message="Loading images" />

    <div v-else>
      <p class="font-QuestrialFont text-gray-500 mt-5 mb-4">
        Select an image to download
      </p>

      <div class="grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-5">
        <div v-for="(img, index) in images" :key="index">
          <EachImage
            data-aos="fade-in"
            data-aos-easing="ease-in-out"
            data-aos-duration="500"
            :img="img"
          />
        </div>
      </div>

      <LineBreak />
    </div>
  </div>
</template>

<script>
import getImages from "../../api/getImages";
import Title from "./Title.vue";
import EachImage from "./EachImage.vue";
import LineBreak from "../LineBreak.vue";
import LoadingSpinner from "../LoadingSpinner.vue";

export default {
  name: "Images",

  components: {
    Title,
    EachImage,
    LineBreak,
    LoadingSpinner,
  },

  data() {
    return {
      images: [],
      loading: false,
    };
  },

  async created() {
    this.loading = true;
    const { images } = await getImages();
    this.images = images;
    this.loading = false;
  },
};
</script>

